import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Eye, Ship, Search, Trash2, FileDown, AlertTriangle } from 'lucide-react';
import api from '../utils/api';
import { toast } from 'sonner';
import * as XLSX from 'xlsx';

// Dünya gemi kayıt bayrakları (önde gelen denizcilik ülkeleri ve tüm ülkeler)
const SHIP_FLAGS = [
  // Önde gelen gemi kayıt bayrakları
  { code: 'PA', name: 'Panama', popular: true },
  { code: 'LR', name: 'Liberia', popular: true },
  { code: 'MH', name: 'Marshall Islands', popular: true },
  { code: 'HK', name: 'Hong Kong', popular: true },
  { code: 'SG', name: 'Singapore', popular: true },
  { code: 'MT', name: 'Malta', popular: true },
  { code: 'BS', name: 'Bahamas', popular: true },
  { code: 'GR', name: 'Greece', popular: true },
  { code: 'CN', name: 'China', popular: true },
  { code: 'JP', name: 'Japan', popular: true },
  { code: 'TR', name: 'Turkey', popular: true },
  { code: 'CY', name: 'Cyprus', popular: true },
  { code: 'IT', name: 'Italy', popular: true },
  { code: 'NO', name: 'Norway', popular: true },
  { code: 'KR', name: 'South Korea', popular: true },
  { code: 'DK', name: 'Denmark', popular: true },
  { code: 'GB', name: 'United Kingdom', popular: true },
  { code: 'US', name: 'United States', popular: true },
  // Diğer ülkeler (alfabetik)
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CG', name: 'Congo' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'EG', name: 'Egypt' },
  { code: 'EE', name: 'Estonia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LY', name: 'Libya' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'MX', name: 'Mexico' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russia' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syria' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' }
];

const Vessels = () => {
  const [vessels, setVessels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [shipFlags, setShipFlags] = useState(SHIP_FLAGS); // Varsayılan bayraklar
  const [flagSearchTerm, setFlagSearchTerm] = useState('');
  const [showFlagDropdown, setShowFlagDropdown] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    imo: '',
    mmsi: '',
    call_sign: '',
    flag: '',
    vessel_type: 'container',
    owner: '',
    manager: '',
    gross_tonnage: '',
    net_tonnage: '',
    dwt: '',
    notes: '',
    is_problematic: false,
    problematic_reason: ''
  });

  useEffect(() => {
    loadVessels();
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await api.get('/settings');
      if (response.data.ship_flags && response.data.ship_flags.length > 0) {
        setShipFlags(response.data.ship_flags);
      }
    } catch (error) {
      console.log('Settings yüklenemedi, varsayılan bayraklar kullanılıyor');
    }
  };

  const loadVessels = async () => {
    try {
      const response = await api.get('/vessels');
      setVessels(response.data);
    } catch (error) {
      toast.error('Gemiler yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  // Filtrelenmiş bayraklar
  const filteredFlags = shipFlags.filter(flag =>
    flag.name.toLowerCase().includes(flagSearchTerm.toLowerCase()) ||
    flag.code.toLowerCase().includes(flagSearchTerm.toLowerCase())
  );

  // Popüler ve diğer bayrakları ayır
  const popularFlags = filteredFlags.filter(f => f.popular);
  const otherFlags = filteredFlags.filter(f => !f.popular);

  // Bayrak seçildiğinde
  const handleFlagSelect = (flagName) => {
    setFormData({ ...formData, flag: flagName });
    setFlagSearchTerm('');
    setShowFlagDropdown(false);
  };

  const handleSearch = async () => {
    if (!searchTerm) {
      loadVessels();
      return;
    }
    try {
      const response = await api.get(`/vessels?search=${searchTerm}`);
      setVessels(response.data);
    } catch (error) {
      toast.error('Arama başarısız');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Zorunlu alan validasyonu
    const requiredFields = {
      imo: 'IMO Numarası',
      flag: 'Bayrak',
      vessel_type: 'Gemi Tipi',
      owner: 'Sahip',
      gross_tonnage: 'Gros Tonaj',
      net_tonnage: 'Net Tonaj'
    };

    for (const [field, label] of Object.entries(requiredFields)) {
      if (!formData[field] || formData[field] === '') {
        toast.error(`${label} alanı zorunludur`);
        return;
      }
    }

    try {
      const submitData = { ...formData };
      ['gross_tonnage', 'net_tonnage', 'dwt'].forEach(field => {
        if (submitData[field] === '') submitData[field] = null;
        else submitData[field] = parseFloat(submitData[field]);
      });

      if (selectedVessel) {
        await api.put(`/vessels/${selectedVessel.id}`, submitData);
        toast.success('Gemi başarıyla güncellendi');
      } else {
        await api.post('/vessels', submitData);
        toast.success('Gemi başarıyla oluşturuldu');
      }
      setShowModal(false);
      resetForm();
      loadVessels();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gemi kaydedilemedi');
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      imo: '',
      mmsi: '',
      call_sign: '',
      flag: '',
      vessel_type: 'container',
      owner: '',
      manager: '',
      gross_tonnage: '',
      net_tonnage: '',
      dwt: '',
      notes: '',
      is_problematic: false,
      problematic_reason: ''
    });
    setSelectedVessel(null);
  };

  const handleEdit = (vessel) => {
    setSelectedVessel(vessel);
    setFormData({
      name: vessel.name,
      imo: vessel.imo || '',
      mmsi: vessel.mmsi || '',
      call_sign: vessel.call_sign || '',
      flag: vessel.flag || '',
      vessel_type: vessel.vessel_type || 'container',
      owner: vessel.owner || '',
      manager: vessel.manager || '',
      gross_tonnage: vessel.gross_tonnage || '',
      net_tonnage: vessel.net_tonnage || '',
      dwt: vessel.dwt || '',
      notes: vessel.notes || '',
      is_problematic: vessel.is_problematic || false,
      problematic_reason: vessel.problematic_reason || ''
    });
    setShowModal(true);
  };

  const handleViewDetail = (vessel) => {
    setSelectedVessel(vessel);
    setShowDetail(true);
  };

  const handleDelete = async (vesselId, vesselName) => {
    if (!window.confirm(`"${vesselName}" gemisini silmek istediğinizden emin misiniz?`)) return;
    
    try {
      await api.delete(`/vessels/${vesselId}`);
      toast.success('Gemi başarıyla silindi');
      loadVessels();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gemi silinemedi');
    }
  };

  const exportToExcel = () => {
    try {
      // Gemi verilerini hazırla
      const excelData = vessels.map((vessel, index) => ({
        'Sıra': index + 1,
        'Gemi Adı': vessel.name || '-',
        'IMO Numarası': vessel.imo || '-',
        'MMSI': vessel.mmsi || '-',
        'Çağrı İşareti': vessel.call_sign || '-',
        'Bayrak': vessel.flag || '-',
        'Gemi Tipi': vessel.vessel_type ? vessel.vessel_type.replace('_', ' ').toUpperCase() : '-',
        'Sahip': vessel.owner || '-',
        'İşleten': vessel.manager || '-',
        'Gros Tonaj (GRT)': vessel.gross_tonnage || '-',
        'Net Tonaj (NRT)': vessel.net_tonnage || '-',
        'DWT': vessel.dwt || '-',
        'Notlar': vessel.notes || '-',
        'Oluşturma Tarihi': vessel.created_at ? new Date(vessel.created_at).toLocaleDateString('tr-TR') : '-'
      }));

      // Worksheet oluştur
      const ws = XLSX.utils.json_to_sheet(excelData);
      
      // Kolon genişliklerini ayarla
      ws['!cols'] = [
        { wch: 6 },  // Sıra
        { wch: 25 }, // Gemi Adı
        { wch: 15 }, // IMO
        { wch: 12 }, // MMSI
        { wch: 15 }, // Çağrı İşareti
        { wch: 15 }, // Bayrak
        { wch: 18 }, // Gemi Tipi
        { wch: 25 }, // Sahip
        { wch: 25 }, // İşleten
        { wch: 15 }, // GRT
        { wch: 15 }, // NRT
        { wch: 12 }, // DWT
        { wch: 30 }, // Notlar
        { wch: 15 }  // Oluşturma Tarihi
      ];

      // Workbook oluştur
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Gemiler');

      // Dosya adı oluştur
      const fileName = `gemiler_${new Date().toLocaleDateString('tr-TR').replace(/\./g, '_')}.xlsx`;

      // Excel dosyasını indir
      XLSX.writeFile(wb, fileName);
      
      toast.success(`${vessels.length} gemi Excel'e aktarıldı`);
    } catch (error) {
      console.error('Excel export error:', error);
      toast.error('Excel\'e aktarım başarısız oldu');
    }
  };

  return (
    <div className="content">
      <div className="topbar">
        <h1 className="topbar-title" data-testid="page-title">Gemi Kayıt Sistemi</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button 
            className="btn btn-secondary" 
            onClick={exportToExcel}
            data-testid="export-excel-btn"
            disabled={vessels.length === 0}
          >
            <FileDown size={18} />
            Excel'e Aktar
          </button>
          <button className="btn btn-primary" onClick={() => setShowModal(true)} data-testid="add-vessel-btn">
            <Plus size={18} />
            Gemi Ekle
          </button>
        </div>
      </div>
      
      <div style={{ padding: '2rem' }}>
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-body" style={{ padding: '1rem' }}>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <div style={{ flex: 1, position: 'relative' }}>
                <input type="text" className="form-input" placeholder="İsim, IMO veya bayrak ile arayın..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSearch()} data-testid="search-input" />
                <Search size={20} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }} />
              </div>
              <button className="btn btn-secondary" onClick={handleSearch} data-testid="search-btn">Ara</button>
              {searchTerm && <button className="btn btn-secondary" onClick={() => { setSearchTerm(''); loadVessels(); }}>Temizle</button>}
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            {loading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>Yükleniyor...</div>
            ) : vessels.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon"><Ship /></div>
                <h3 className="empty-state-title">Henüz gemi yok</h3>
                <p className="empty-state-text">Kayıt sistemine ilk geminizi ekleyin</p>
                <button className="btn btn-primary" onClick={() => setShowModal(true)}><Plus size={18} />Gemi Ekle</button>
              </div>
            ) : (
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Gemi Adı</th>
                      <th>IMO</th>
                      <th>Bayrak</th>
                      <th>Tip</th>
                      <th>GRT / NRT</th>
                      <th>Sahip</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vessels.map((vessel) => (
                      <tr 
                        key={vessel.id} 
                        data-testid={`vessel-row-${vessel.id}`}
                        style={{
                          backgroundColor: vessel.is_problematic ? '#fef2f2' : 'inherit',
                          borderLeft: vessel.is_problematic ? '4px solid #ef4444' : 'none'
                        }}
                      >
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                            {vessel.is_problematic && (
                              <span 
                                title={vessel.problematic_reason || 'Sorunlu gemi'}
                                style={{ 
                                  color: '#ef4444',
                                  cursor: 'help',
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexShrink: 0
                                }}
                              >
                                <AlertTriangle size={14} />
                              </span>
                            )}
                            <span 
                              title={vessel.name}
                              style={{ 
                                color: vessel.is_problematic ? '#dc2626' : 'inherit',
                                fontWeight: 600,
                                maxWidth: '160px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block'
                              }}
                            >
                              {vessel.name}
                            </span>
                          </div>
                          {vessel.is_problematic && vessel.problematic_reason && (
                            <div style={{ 
                              fontSize: '0.7rem', 
                              color: '#dc2626',
                              marginTop: '0.125rem',
                              maxWidth: '160px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {vessel.problematic_reason}
                            </div>
                          )}
                        </td>
                        <td style={{ fontSize: '0.8rem' }}>{vessel.imo || '-'}</td>
                        <td style={{ fontSize: '0.8rem' }}>{vessel.flag || '-'}</td>
                        <td>{vessel.vessel_type ? <span className="badge badge-paid" style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}>{vessel.vessel_type.replace('_', ' ')}</span> : '-'}</td>
                        <td style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                          {vessel.gross_tonnage ? `${vessel.gross_tonnage} GRT` : '-'} / {vessel.net_tonnage ? `${vessel.net_tonnage} NRT` : '-'}
                        </td>
                        <td style={{ maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8rem' }} title={vessel.owner}>
                          {vessel.owner || '-'}
                        </td>
                        <td>
                          <div className="action-buttons">
                            <button className="action-btn" onClick={() => handleViewDetail(vessel)} title="View Details" data-testid={`view-vessel-${vessel.id}`}><Eye size={16} /></button>
                            <button className="action-btn" onClick={() => handleEdit(vessel)} title="Edit" data-testid={`edit-vessel-${vessel.id}`}><Edit2 size={16} /></button>
                            <button className="action-btn action-btn-danger" onClick={() => handleDelete(vessel.id, vessel.name)} title="Delete" data-testid={`delete-vessel-${vessel.id}`}><Trash2 size={16} /></button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header">
              <h2 className="modal-title" data-testid="modal-title">{selectedVessel ? 'Gemiyi Düzenle' : 'Yeni Gemi Ekle'}</h2>
              <button className="modal-close" onClick={() => { setShowModal(false); resetForm(); }}>×</button>
            </div>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
              <div className="modal-body" style={{ overflowY: 'auto', flex: 1 }}>
                <div className="form-group">
                  <label className="form-label">Gemi Adı *</label>
                  <input type="text" className="form-input" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required data-testid="vessel-name-input" />
                </div>
                <div className="form-row">
                  <div className="form-group"><label className="form-label">IMO Numarası *</label><input type="text" className="form-input" value={formData.imo} onChange={(e) => setFormData({ ...formData, imo: e.target.value })} data-testid="imo-input" /></div>
                  <div className="form-group"><label className="form-label">MMSI</label><input type="text" className="form-input" value={formData.mmsi} onChange={(e) => setFormData({ ...formData, mmsi: e.target.value })} data-testid="mmsi-input" /></div>
                  <div className="form-group"><label className="form-label">Çağrı İşareti</label><input type="text" className="form-input" value={formData.call_sign} onChange={(e) => setFormData({ ...formData, call_sign: e.target.value })} data-testid="call-sign-input" /></div>
                </div>
                <div className="form-row">
                  <div className="form-group" style={{ position: 'relative' }}>
                    <label className="form-label">Bayrak *</label>
                    <div style={{ position: 'relative' }}>
                      <div style={{ position: 'relative' }}>
                        <Search size={16} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', zIndex: 1 }} />
                        <input
                          type="text"
                          className="form-input"
                          placeholder="Bayrak ara..."
                          value={showFlagDropdown ? flagSearchTerm : formData.flag}
                          onChange={(e) => {
                            setFlagSearchTerm(e.target.value);
                            setShowFlagDropdown(true);
                          }}
                          onFocus={() => {
                            setShowFlagDropdown(true);
                            setFlagSearchTerm('');
                          }}
                          onBlur={() => {
                            setTimeout(() => setShowFlagDropdown(false), 200);
                          }}
                          style={{ paddingLeft: '36px' }}
                          data-testid="flag-select"
                        />
                      </div>
                      {showFlagDropdown && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: 'white',
                          border: '1px solid #e2e8f0',
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          maxHeight: '300px',
                          overflowY: 'auto',
                          zIndex: 1000
                        }}>
                          {popularFlags.length > 0 && (
                            <>
                              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#fef3c7', color: '#92400e', fontSize: '0.75rem', fontWeight: 600 }}>
                                ⭐ Popüler Bayraklar
                              </div>
                              {popularFlags.map(flag => (
                                <div
                                  key={flag.code}
                                  onClick={() => handleFlagSelect(flag.name)}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f1f5f9',
                                    backgroundColor: formData.flag === flag.name ? '#e0f2fe' : 'white'
                                  }}
                                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f9ff'}
                                  onMouseLeave={(e) => e.target.style.backgroundColor = formData.flag === flag.name ? '#e0f2fe' : 'white'}
                                >
                                  <span style={{ fontWeight: 500 }}>{flag.name}</span>
                                  <span style={{ marginLeft: '0.5rem', color: '#94a3b8', fontSize: '0.75rem' }}>({flag.code})</span>
                                </div>
                              ))}
                            </>
                          )}
                          {otherFlags.length > 0 && (
                            <>
                              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#f1f5f9', color: '#475569', fontSize: '0.75rem', fontWeight: 600 }}>
                                🌍 Diğer Bayraklar
                              </div>
                              {otherFlags.map(flag => (
                                <div
                                  key={flag.code}
                                  onClick={() => handleFlagSelect(flag.name)}
                                  style={{
                                    padding: '0.5rem 1rem',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f1f5f9',
                                    backgroundColor: formData.flag === flag.name ? '#e0f2fe' : 'white'
                                  }}
                                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f9ff'}
                                  onMouseLeave={(e) => e.target.style.backgroundColor = formData.flag === flag.name ? '#e0f2fe' : 'white'}
                                >
                                  <span style={{ fontWeight: 500 }}>{flag.name}</span>
                                  <span style={{ marginLeft: '0.5rem', color: '#94a3b8', fontSize: '0.75rem' }}>({flag.code})</span>
                                </div>
                              ))}
                            </>
                          )}
                          {filteredFlags.length === 0 && (
                            <div style={{ padding: '1rem', textAlign: 'center', color: '#94a3b8' }}>
                              Bayrak bulunamadı
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group"><label className="form-label">Gemi Tipi *</label><select className="form-select" value={formData.vessel_type} onChange={(e) => setFormData({ ...formData, vessel_type: e.target.value })} data-testid="type-select"><option value="container">Konteyner</option><option value="bulk_carrier">Dökme Yük</option><option value="tanker">Tanker</option><option value="general_cargo">Genel Kargo</option><option value="ro_ro">Ro-Ro</option><option value="passenger">Yolcu</option><option value="other">Diğer</option></select></div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label className="form-label">Sahip *</label><input type="text" className="form-input" value={formData.owner} onChange={(e) => setFormData({ ...formData, owner: e.target.value })} data-testid="owner-input" /></div>
                  <div className="form-group"><label className="form-label">İşleten</label><input type="text" className="form-input" value={formData.manager} onChange={(e) => setFormData({ ...formData, manager: e.target.value })} data-testid="manager-input" /></div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label className="form-label">Gros Tonaj *</label><input type="number" className="form-input" value={formData.gross_tonnage} onChange={(e) => setFormData({ ...formData, gross_tonnage: e.target.value })} step="0.01" data-testid="gt-input" /></div>
                  <div className="form-group"><label className="form-label">Net Tonaj *</label><input type="number" className="form-input" value={formData.net_tonnage} onChange={(e) => setFormData({ ...formData, net_tonnage: e.target.value })} step="0.01" data-testid="nt-input" /></div>
                  <div className="form-group"><label className="form-label">DWT</label><input type="number" className="form-input" value={formData.dwt} onChange={(e) => setFormData({ ...formData, dwt: e.target.value })} step="0.01" data-testid="dwt-input" /></div>
                </div>
                <div className="form-group"><label className="form-label">Notlar</label><textarea className="form-input" value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows="3" data-testid="notes-input" /></div>
                
                {/* Sorunlu Gemi Bölümü */}
                <div style={{ 
                  marginTop: '1.5rem',
                  padding: '1rem',
                  background: formData.is_problematic ? '#fef2f2' : '#f8fafc',
                  border: formData.is_problematic ? '1px solid #fecaca' : '1px solid #e2e8f0',
                  borderRadius: '8px'
                }}>
                  <div className="form-group" style={{ marginBottom: formData.is_problematic ? '1rem' : 0 }}>
                    <label style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '0.75rem',
                      cursor: 'pointer',
                      fontWeight: 500,
                      color: formData.is_problematic ? '#dc2626' : '#374151'
                    }}>
                      <input
                        type="checkbox"
                        checked={formData.is_problematic}
                        onChange={(e) => setFormData({ 
                          ...formData, 
                          is_problematic: e.target.checked,
                          problematic_reason: e.target.checked ? formData.problematic_reason : ''
                        })}
                        style={{ 
                          width: '18px', 
                          height: '18px',
                          accentColor: '#ef4444'
                        }}
                      />
                      <AlertTriangle size={18} color={formData.is_problematic ? '#ef4444' : '#9ca3af'} />
                      Sorunlu Gemi
                    </label>
                  </div>
                  
                  {formData.is_problematic && (
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label className="form-label" style={{ color: '#dc2626' }}>
                        Sorun Sebebi *
                      </label>
                      <textarea
                        className="form-input"
                        value={formData.problematic_reason}
                        onChange={(e) => setFormData({ ...formData, problematic_reason: e.target.value })}
                        rows="2"
                        placeholder="Gecikmeli operasyon, belge eksikliği, teknik sorunlar vb."
                        style={{
                          borderColor: '#fecaca',
                          background: '#fff'
                        }}
                        required
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => { setShowModal(false); resetForm(); }}>İptal</button>
                <button type="submit" className="btn btn-primary" data-testid="save-vessel-btn">{selectedVessel ? 'Gemiyi Güncelle' : 'Gemi Oluştur'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDetail && selectedVessel && (
        <div className="modal-overlay">
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
            <div className="modal-header"><h2 className="modal-title" data-testid="detail-title">{selectedVessel.name}</h2><button className="modal-close" onClick={() => setShowDetail(false)}>×</button></div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                <div><h4 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>Gemi Bilgileri</h4><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>IMO Numarası</div><div style={{ fontWeight: 600 }}>{selectedVessel.imo || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>MMSI</div><div>{selectedVessel.mmsi || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>Çağrı İşareti</div><div>{selectedVessel.call_sign || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>Bayrak</div><div>{selectedVessel.flag || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>Tip</div><div>{selectedVessel.vessel_type ? selectedVessel.vessel_type.replace('_', ' ').toUpperCase() : 'N/A'}</div></div></div>
                <div><h4 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>Teknik Detaylar</h4><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>Gros Tonaj</div><div style={{ fontWeight: 600 }}>{selectedVessel.gross_tonnage || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>Net Tonaj</div><div>{selectedVessel.net_tonnage || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>DWT</div><div>{selectedVessel.dwt || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>Sahip</div><div>{selectedVessel.owner || 'N/A'}</div></div><div style={{ marginBottom: '0.75rem' }}><div style={{ fontSize: '0.875rem', color: '#64748b' }}>İşleten</div><div>{selectedVessel.manager || 'N/A'}</div></div></div>
              </div>
              {selectedVessel.notes && <div style={{ marginTop: '1.5rem' }}><h4 style={{ marginBottom: '0.5rem', color: 'var(--primary)' }}>Notlar</h4><div style={{ padding: '1rem', background: '#f8fafc', borderRadius: '8px' }}>{selectedVessel.notes}</div></div>}
              {selectedVessel.last_port_calls && selectedVessel.last_port_calls.length > 0 && <div style={{ marginTop: '1.5rem' }}><h4 style={{ marginBottom: '0.5rem', color: 'var(--primary)' }}>Son Liman Çağrıları</h4><div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>{selectedVessel.last_port_calls.map((pc, idx) => <span key={idx} className="badge badge-sent">{pc}</span>)}</div></div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Vessels;